import { configureStore } from "@reduxjs/toolkit";
import statesReducer from "../Slices/statesSlice";
import countriesReducer from "../Slices/countriesSlice";
import teachersReducer from "../Slices/teachersSlice";
import subjectsReducer from "../Slices/subjectsSlice";
import timeIntervalsReducer from "../Slices/timeIntervalsSlice";
import classesReducer from "../Slices/classesSlice";
import sessionsReducer from "../Slices/sessionsSlice";
import gradesReducer from "../Slices/gradesSlice";
import feeTypesReducer from "../Slices/FeeTypeSlice";

export const store = configureStore({
  reducer: {
    states: statesReducer,
    countries: countriesReducer,
    teachers: teachersReducer,
    subjects: subjectsReducer,
    timeIntervals: timeIntervalsReducer,
    classes: classesReducer,
    sessions: sessionsReducer,
    grades: gradesReducer,
    feeTypes: feeTypesReducer,
  },
});
